<template>
  <div class="login">
    <div class="center_box t-10">
      <div class="login_tit l-h70">
        找回密码
      </div>
      <div class="login_min mt0">
        <vue-form :state="formstate" id="loginForm" autocomplete="off">
          <validate tag="div" class="p_rel">
            <p>手机号</p>
            <input class="pass_word" v-model="params.mobile" type="text" name="mobile" placeholder="" required pattern="^[1][0-9]{10}$">
            <field-messages name="mobile" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">手机号不能为空</div>
              <div slot="pattern" class="errorMessage">请填写正确的手机号</div>
            </field-messages>
          </validate>
          <validate tag="div" class="p_rel">
            <p>验证码</p>
            <div class="clearfix">
              <input id="" class="pass_word i_w200 fl" name="idCode" v-model="params.code" placeholder="" required pattern="^\d{6}$">
              <input class="pass_word i_w100 fr" :class="{can_login:!smsBtnDisabled}" type="button" @click="getSmsCode" :disabled="smsBtnDisabled" :value="smsBtnTxt">
            </div>
            <field-messages name="idCode" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">手机验证码不能为空</div>
              <div slot="pattern" class="errorMessage">请填写正确的手机验证码</div>
            </field-messages>
          </validate>
          <validate tag="div" class="p_rel">
            <p>新密码</p>
            <input class="pass_word" v-model="params.password" type="password" name="newPassword" placeholder="" required pattern="^\d{6}$">
            <field-messages name="newPassword" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">新密码不能为空</div>
              <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
            </field-messages>
          </validate>
          <validate tag="div" style="position: relative;">
            <p>再次输入新密码</p>
            <input class="pass_word" v-model="params.passwordAgain" type="password" name="passwordAgain" placeholder="" required pattern="^\d{6}$">
            <field-messages name="passwordAgain" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">新密码不能为空</div>
              <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
            </field-messages>
          </validate>
          <div>
            <button  :class="{can_login:isNext == true}" @click.prevent="goToNext" type="" :disabled="!isNext">完成</button>
          </div>
        </vue-form>
      </div>
      <toastTips :content="toastContent" :is-show="toast"></toastTips>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import toastTips from '../../components/layer/toastTips'
  export default {
    name: 'forgetPasswordStep1',
    components:{
      toastTips
    },
    data () {
      return {
        formstate:{},
        params : {
          mobile:'',
          code:'',
          password:'',
          passwordAgain:''
        },
        isNext:false,
        errorMsg:'',
        step:2,
        toast:false,
        toastContent:'',
        smsBtnTxt:'点击获取',
        smsBtnDisabled:false
      }
    },
    methods:{
      getSmsCode:function(){
        this.smsBtnDisabled=true;
        axios.post('/login/sendSms',qs.stringify(
          {
            mobile:this.params.mobile,
            type:'forget'
          }
        )).then((response)=>{
          var that=this;
          console.log(response);
          if(response.data.code == 22000){
            let num = 120;
            let timer = setInterval(function(){
              if(num!=0){
                num--;
                that.smsBtnTxt=num+'秒后重发';
              }else{
                num=120;
                that.smsBtnTxt='点击获取';
                that.smsBtnDisabled=false;
                clearInterval(timer);
              }

            },1000);
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            this.smsBtnDisabled=false;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      goToNext:function(){
        var that=this;
        if(this.params.password==this.params.passwordAgain){
          axios.post('/login/changePassword',qs.stringify(
            this.params
          )).then((response)=>{

            if(response.data.code == 22000){
              window.location.href='/#/login'
            }else{
              that.toast=true;
              that.toastContent=response.data.message;
              setTimeout(function(){
                that.toast=false;
                that.toastContent='';
              },3000)
            }
          })
        }else{
          that.toast=true;
          that.toastContent='两次输入的密码不一致';
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000)
        }

      }
    },
    watch:{
      'formstate.$invalid':function(){
        if(!this.formstate.$invalid){
          this.isNext=true;
        }else{
          this.isNext=false;
        }

      }
    }

  }
</script>
<style lang="less" scoped>
  .l-h70{
    line-height: 70px;
  }
  .login_min{
  div{
    margin-top: 10px;
  p{
    line-height: 40px;
    font-size: 16px;
  }
  }
  }
  .t80{
    top:80px!important;
  }
  .t-10{
    top: 10%!important;
    margin-top: 0!important;
  }
  .p_rel{
    position: relative !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/forget_password/step1.vue